/**
 * i18n messages for the scholar signature-consent panel (en/ar). Registered in
 * core/plugins/i18n.ts under its own top-level `signatureConsent` key: that
 * merge is shallow, so the namespace must not be shared with another file.
 * CSP-safe compiler: only `{named}` placeholders.
 */
export const signatureConsentMessages = {
  en: {
    signatureConsent: {
      title: "Signature consent",
      loading: "Loading…",
      none: "No consent on file",
      fileLabel: "Upload signed consent document",
      uploadedOn: "Uploaded {date}",
      uploadedBy: "by {name}",
      view: "View",
      withdraw: "Withdraw",
      withdrawnHistory: "Withdrawn ({count})",
      withdrawnOn: "withdrawn {date}",
      confirm: {
        title: "Withdraw consent?",
        text: "Withdrawing affects future certificates only. Certificates already signed keep this signature.",
        confirmButtonText: "Withdraw",
        cancelButtonText: "Cancel",
      },
      requestFailed: "The request failed (HTTP {status}).",
      requestFailedGeneric: "The request failed.",
    },
  },
  ar: {
    signatureConsent: {
      title: "موافقة التوقيع",
      loading: "جارٍ التحميل…",
      none: "لا توجد موافقة محفوظة",
      fileLabel: "رفع وثيقة الموافقة الموقّعة",
      uploadedOn: "تم الرفع في {date}",
      uploadedBy: "بواسطة {name}",
      view: "عرض",
      withdraw: "سحب",
      withdrawnHistory: "الموافقات المسحوبة ({count})",
      withdrawnOn: "سُحبت في {date}",
      confirm: {
        title: "هل تريد سحب الموافقة؟",
        text: "يؤثر السحب على الشهادات المستقبلية فقط. الشهادات الموقّعة مسبقًا تحتفظ بهذا التوقيع.",
        confirmButtonText: "سحب",
        cancelButtonText: "إلغاء",
      },
      requestFailed: "فشل الطلب (HTTP {status}).",
      requestFailedGeneric: "فشل الطلب.",
    },
  },
};
